import React, { useState, useEffect, useContext } from "react";
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import {
    Dialog, DialogTitle, DialogContent, Button, Typography,
    DialogActions, IconButton, Stepper, Step, StepButton, Grid, Tooltip, TextField,
    MenuItem, Box, Card, CardContent, FormControlLabel, Checkbox, Autocomplete
}
    from '@mui/material';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import { DataGrid, esES, GridActionsCellItem, GridToolbar } from "@mui/x-data-grid";
import CloseIcon from '@mui/icons-material/Close';
import Check from '@mui/icons-material/Check';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import 'moment/locale/es-mx';
import { esES as localeDate } from '@mui/x-date-pickers/locales'
import DeleteIcon from '@mui/icons-material/Delete';
import { observer } from "mobx-react-lite";
import { RootStoreContext } from "../../app/store/root";
import { ErrorMessages } from "../../app/util/messages";
import DialogComponent from "../../app/common/DialogComponent";
import { toJS } from "mobx";
import { EnumStatusEmbarqueString } from "../../shared/Enumerables";
import { ModalComponent } from "../../app/common/ModalComponent";
import { blobToBase64 } from "../../app/util/util";

// STEPER
const QontoConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
        top: 10,
        left: 'calc(-50% + 16px)',
        right: 'calc(50% + 16px)',
    },
    [`&.${stepConnectorClasses.active}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            borderColor: 'primary',
        },
    },
    [`&.${stepConnectorClasses.completed}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            borderColor: 'primary',
        },
    },
    [`& .${stepConnectorClasses.line}`]: {
        borderColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
        borderTopWidth: 3,
        borderRadius: 1,
    },
}));

const QontoStepIconRoot = styled('div')(({ theme, ownerState }) => ({
    color: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#eaeaf0',
    display: 'flex',
    height: 22,
    alignItems: 'center',
    ...(ownerState.active && {
        color: '#784af4',
    }),
    '& .QontoStepIcon-completedIcon': {
        color: '#784af4',
        zIndex: 1,
        fontSize: 18,
    },
    '& .QontoStepIcon-circle': {
        width: 8,
        height: 8,
        borderRadius: '50%',
        backgroundColor: 'currentColor',
    },
}));

function QontoStepIcon(props) {
    const { active, completed, className } = props;

    return (
        <QontoStepIconRoot ownerState={{ active }} className={className}>
            {completed ? (
                <Check className="QontoStepIcon-completedIcon" />
            ) : (
                <div className="QontoStepIcon-circle" />
            )}
        </QontoStepIconRoot>
    );
}

QontoStepIcon.propTypes = {
    /**
     * Whether this step is active.
     * @default false
     */
    active: PropTypes.bool,
    className: PropTypes.string,
    /**
     * Mark the step as completed. Is passed to child components.
     * @default false
     */
    completed: PropTypes.bool,
};

const steps = ['Selección de guías', 'Creación de embarque'];
const label = { inputProps: { 'aria-label': 'Checkbox demo' } };


const ModalEmbarques = ({ onClose, onFinish, modelEditar }) => {

    const rootStore = useContext(RootStoreContext);

    const {
        consultarEnviosParaEmbarque: _consultarEnviosParaEmbarque,
        bloqueoEnvio,
        notificarEnvioActualizado,
    } = rootStore.shipmentStore;

    const {
        entities: proveedoresList,
        getAll: getAllProveedor
    } = rootStore.proveedorStore

    const {
        crearEmbarque: _crearEmbarque,
        editarEmbarque: _editarEmbarque,
        getEmbarqueFile: _getEmbarqueFile
    } = rootStore.embarqueStore

    const [filtro, setFiltro] = useState({
        NumeroGuia: null,
        IdProveedor: null,
        FechaInicio: null,
        FechaFin: null,
    });

    const [proveedoresFiltro, setProveedoresFiltro] = useState([])
    //en edicion del ambarque, guardar las guias eliminadas, agregadas, sinmovimiento para envio de notificaciones
    const [activeStep, setActiveStep] = useState(0);

    const [guiasEliminadas, setGuiasEliminadas] = useState([])
    const [guiasAgregadas, setGuiasAgregadas] = useState([])
    const [guiasPermanecen, setGuiasPermanecen] = useState([])
    const [idEmbarque, setIdEmbarque] = useState(null)

    const [bajaEnvios, setBajaEnvios] = useState(false)
    const [altaEnvios, setAltaEnvios] = useState(false)
    const [esEditar, setEsEditar] = useState(false)
    const [showDialogEnviosEnEmbarques, setShowDialogEnviosEnEmbarques] = useState(false);
    const [showDialogEnviosNotificacion, setShowDialogEnviosNotificacion] = useState(false);

    const [enviosMensajeError, setEnviosMensajeError] = useState('');
    const [showDialogClear, setShowDialogClear] = useState(false);
    const [showDialogConfirmar, setShowDialogConfirmar] = useState(false);


    const [pageSize, setPageSize] = React.useState(5);
    const [pageSize2, setPageSize2] = React.useState(5);
    //variable que almacena los envios que se consultan en bd
    const [envios, setEnvios] = React.useState([])
    //variable que almacena los envios seleccionados que aun no se agregan 
    const [enviosSeleccionados, setEnviosSeleccionados] = React.useState([])
    //al hacer click en agregar se pasan los envios a esta variable.
    const [enviosEmbarque, setEnviosEmbarque] = useState([])
    const [modelEmbarque, setModelEmbarque] = useState({
        
        NumeroCartaPorte: null,
        FechaEstimadaLlegada: null,
        Comentario: null,
        IdEnvios: [],
        Estatus: EnumStatusEmbarqueString.Creado,
        NotificacionNuevas: false,
        NotificacionEliminadas: false,
        NotificacionSinModificar: false,
    })

    const [errors, setErrors] = useState({
        NumeroCartaPorte: null
    })
    const [messages, setMessages] = useState({
        NumeroCartaPorte: ''
    })

    const setError = (key, value) => {
        setErrors({ ...errors, ...{ [key]: value } });
    }
    const setMessage = (key, value) => {
        setMessages({ ...messages, ...{ [key]: value } });
    }
    const setValue = (key, value) => {
        setModelEmbarque({ ...modelEmbarque, ...{ [key]: value } });
    }

    useEffect(() => {
        if (proveedoresList && proveedoresList?.length > 0) {
            let newProveedores = [{ id: "-1", proveedores: "Todos" }].concat(proveedoresList.map(a => { return { id: a.id, proveedores: a.proveedores } }))
            setProveedoresFiltro(newProveedores);
        }
    }, [proveedoresList]);

    useEffect(() => {
        setValue("IdEnvios", enviosEmbarque.map(a => { return a.idGuia }))
    }, [enviosEmbarque])

    useEffect(() => {
        loadDataPage()
        if (modelEditar != null) {
            var model = toJS(modelEditar)
            setEsEditar(true)
            setIdEmbarque(model.idEmbarque)
            setModelEmbarque({
                NumeroCartaPorte: model.numeroCartaPorte,
                FechaEstimadaLlegada: model.fechaEstimadaLlegada,
                Comentario: model.comentario,
                IdEnvios: [],
                Estatus: model.estatus,
                NotificacionNuevas: false,
                NotificacionEliminadas: false,
                NotificacionSinModificar: false,
            })
            setEnviosEmbarque(model.envios.map(a => {
                return {
                    idGuia: a.idGuia,
                    idEstatus: a.idEstatus,
                    numeroGuia: a.numeroGuia,
                    descripcionEnvio: a.descripcionEnvio,
                    fechaEstatus: a.fechaEstatus,
                    numeroCartaPorte: a.numeroCartaPorte,
                    idProveedor: a.idProveedor,
                    proveedor: a.proveedor,
                    destino: a.destino,
                    fechaCreo: a.fechaCreo,
                    fechaEstimadaLlegada: a.fechaEstimadaLlegada
                }
            }))
            setErrors({
                NumeroCartaPorte: false
            })
            getEmbarqueFile(model.idEmbarque)
        }
        if (modelEditar == null) {
            setEsEditar(false)
        }
    }, [])

    const loadDataPage = () => {
        //getAll()
        //getAllPerfiles()
        getAllProveedor()
    }

    const [urlBlob, setUrlBlob] = useState(undefined)
    const handleStep = (step) => {
        setActiveStep(step)
        getEmbarqueFile(idEmbarque)
    };

    const setValueFiltro = (key, value) => {
        setFiltro({ ...filtro, ...{ [key]: value } });
    };

    const consultarEnviosParaEmbarque = async (e) => {
        e.preventDefault()
        if (modelEmbarque?.Estatus?.toUpperCase() !== EnumStatusEmbarqueString.Creado) {
            return
        }
        const initialFilter = {
            NumeroGuia: filtro.NumeroGuia,
            IdProveedor: filtro.IdProveedor < 0 ? null : filtro.IdProveedor,
            FechaInicio: filtro.FechaInicio,
            FechaFin: filtro.FechaFin
        }
        var resp = await _consultarEnviosParaEmbarque(initialFilter)
        if (resp != null) {
            resp = resp.filter(a => !enviosEmbarque.map(a => a.idGuia).includes(a.idGuia))
            setEnvios(resp)
            if (resp.length == 0) {
                rootStore.alertStore.alertInfo("No se encontraron resultados.");
            }
        }
    }

    const agregarEnvios = async (e) => {
        e.preventDefault()
        const resp = await bloqueoEnvio(true, enviosSeleccionados)
        let enviosEmbarques = enviosEmbarque.map(a => { return a })
        let nuevos = envios.filter(a => enviosSeleccionados.includes(a.idGuia)).map(a => { return a })
        let total = enviosEmbarques.concat(nuevos)
        setEnviosEmbarque(total)
        //setEnviosEmbarque(envios.filter(a => enviosSeleccionados.includes(a.idGuia)))
        setEnvios(envios.filter(a => !enviosSeleccionados.includes(a.idGuia)))
    }

    const deleteEnvioEmbarque = async (e) => {
        if (!esEditar)
            await bloqueoEnvio(false, [e.idGuia])
        else if (toJS(modelEditar).envios.findIndex(a => a.idGuia == e.idGuia) < 0)
            await bloqueoEnvio(false, [e.idGuia])

        let indexDelete = enviosEmbarque.findIndex(a => a.idGuia == e.idGuia)
        if (envios.findIndex(a => a.idGuia == e.idGuia) < 0) {
            setEnvios([...envios, ...[enviosEmbarque[indexDelete]]])
        }
        let tempEnviosEmbarque = enviosEmbarque.map(a => { return a })
        tempEnviosEmbarque.splice(indexDelete, 1)
        setEnviosEmbarque(tempEnviosEmbarque)
    }

    const clickContinuar = async () => {
        if (esEditar) {
            editarEmbarque()
        } else {
            crearEmbarque()
        }
    }

    const crearEmbarque = async () => {
        if (modelEmbarque.IdEnvios?.length == 0) {
            rootStore.alertStore.alertError("El embarque requiere al menos una guía.");
            return
        }
        rootStore.logisticBackdropStore.openLoading()
        let resp = await _crearEmbarque(modelEmbarque)
        setTimeout(() => rootStore.logisticBackdropStore.closeLoading(), 1000)
        if (resp != null) {
            if (!resp.success) {
                rootStore.alertStore.alertError(resp.responseMessage);
            } else {
                if (resp.data.exito) {
                    rootStore.alertStore.alertCreateSuccess("Guardado con éxito.");
                    //obtener reporte y mostrarlo en visor.
                    getEmbarqueFile(resp.data.id)
                    setIdEmbarque(resp.data.id)
                    setModelGuardado(true)
                    setActiveStep(1)
                } else {
                    const Errors = {
                        NumeroCartaPorte: false,
                    }
                    const Mensajes = {
                        NumeroCartaPorte: '',
                    }
                    let enviosError = []
                    let _enviosMensajeError = []
                    resp.data.validations.forEach(element => {
                        if (element.campo.toUpperCase() == 'NumeroCartaPorte'.toUpperCase()) {
                            Errors.NumeroCartaPorte = true
                            Mensajes.NumeroCartaPorte = element.mensaje
                        }
                        else {
                            enviosError.push(element.campo)
                            _enviosMensajeError.push(element.mensaje) 
                        }
                    });
                    if (_enviosMensajeError.length > 0) {                        
                        setEnviosMensajeError(_enviosMensajeError)
                        setShowDialogEnviosEnEmbarques(true)
                    }
                    setErrors({ ...Errors })
                    setMessages({ ...Mensajes })
                }
            }
        }
    }

    const editarEmbarque = async () => {        
        let mostrarEnvioActualizacion = false;
        if (modelEmbarque.IdEnvios?.length == 0) {
            rootStore.alertStore.alertError("El embarque requiere al menos una guía.");
            return
        }
        rootStore.logisticBackdropStore.openLoading()
        var model = toJS(modelEditar)
        //obtener guias que no se movieron
        setGuiasPermanecen(model.envios.filter(env => modelEmbarque.IdEnvios.includes(env.idGuia)).map(a => { return a.idGuia }))
        //obtener y validar si se agregaron nuevos envios
        let nuevas = modelEmbarque.IdEnvios.filter(idGuia => !model.envios.map(a => { return a.idGuia }).includes(idGuia)).map(a => { return a })
        if (nuevas.length > 0) {
            setGuiasAgregadas(nuevas)
            setAltaEnvios(true)
            mostrarEnvioActualizacion = true
        }
        //obtenr y validar si se eliminaron envios
        let eliminadas = model.envios.filter(env => !modelEmbarque.IdEnvios.includes(env.idGuia)).map(a => { return a.idGuia })
        if (eliminadas.length > 0) {
            //se Eliminaron envios/guias
            setGuiasEliminadas(eliminadas)
            setBajaEnvios(true)
            mostrarEnvioActualizacion = true
        }
        let resp = await _editarEmbarque(model.idEmbarque, modelEmbarque)
        setTimeout(() => rootStore.logisticBackdropStore.closeLoading(), 500)
        if (resp != null) {
            if (!resp.success) {
                rootStore.alertStore.alertError(resp.responseMessage);
            } else {
                if (resp.data.exito) {
                    rootStore.alertStore.alertCreateSuccess("Embarque actualizado exitosamente.");
                    setModelGuardado(true)
                    if (mostrarEnvioActualizacion) {
                        setShowDialogEnviosNotificacion(true)
                        return
                    }
                    //obtener reporte y mostrarlo en visor.
                    getEmbarqueFile(model.idEmbarque)
                    setActiveStep(1)
                } else {
                    const Errors = {
                        NumeroCartaPorte: false,
                    }
                    const Mensajes = {
                        NumeroCartaPorte: '',
                    }
                    let enviosError = []
                    let _enviosMensajeError = []
                    resp.data.validations.forEach(element => {
                        if (element.campo.toUpperCase() == 'NumeroCartaPorte'.toUpperCase()) {
                            Errors.NumeroCartaPorte = true
                            Mensajes.NumeroCartaPorte = element.mensaje
                        }
                        else {
                            enviosError.push(element.campo)
                            _enviosMensajeError.push(element.mensaje) 
                        }
                    });
                    if (_enviosMensajeError.length > 0) {                        
                        setEnviosMensajeError(_enviosMensajeError)
                        setShowDialogEnviosEnEmbarques(true)
                    }
                    setErrors({ ...Errors })
                    setMessages({ ...Mensajes })
                }
            }
        }
    }

    const confirmarNotificacionActualizacion = async (e) => {
        try {
            e.preventDefault()
            rootStore.logisticBackdropStore.openLoading()
            var guiasNotificaciones = []
            if (modelEmbarque.NotificacionNuevas) {
                guiasNotificaciones = guiasAgregadas
            }
            if (modelEmbarque.NotificacionEliminadas) {
                guiasNotificaciones = guiasNotificaciones.concat(guiasEliminadas)
            }
            if (modelEmbarque.NotificacionSinModificar) {
                guiasNotificaciones = guiasNotificaciones.concat(guiasPermanecen)
            }
            await notificarEnvioActualizado(guiasNotificaciones)
            getEmbarqueFile(idEmbarque)
            setActiveStep(1)
            setShowDialogEnviosNotificacion(false)
            rootStore.logisticBackdropStore.closeLoading()
        } catch (err) {
            rootStore.logisticBackdropStore.closeLoading()
        }

    }

    const getEmbarqueFile = async (idEmbarque) => {
        let pdf = await _getEmbarqueFile(idEmbarque)
        const pdfBase64 = await blobToBase64(pdf.data)
        setUrlBlob(pdfBase64);
    }

    //TABLAS
    const columns = [
        {
            field: 'numeroGuia',
            headerName: 'No. de guía',
            flex: 1,
            headerClassName: 'tableHeaders',
            renderHeader: () => (
                <span className="headerTable">
                    No. de guía
                </span>
            ),
        },
        {
            field: 'proveedor',
            headerName: 'Proveedor',
            flex: 1,
            headerClassName: 'tableHeaders',
            renderHeader: () => (
                <span className="headerTable">
                    Proveedor
                </span>
            ),
        },
        {
            field: 'destino',
            headerName: 'Empresa destino',
            flex: 1,
            headerClassName: 'tableHeaders',
            renderHeader: () => (
                <span className="headerTable">
                    Empresa destino
                </span>
            ),
        },
    ];

    const columnsEmbarque = [
        {
            field: 'numeroGuia',
            headerName: 'No. de guía',
            flex: 1,
            headerClassName: 'tableHeaders',
            renderHeader: () => (
                <span className="headerTable">
                    No. de guía
                </span>
            ),
        },
        {
            field: 'proveedor',
            headerName: 'Proveedor',
            flex: 1,
            headerClassName: 'tableHeaders',
            renderHeader: () => (
                <span className="headerTable">
                    Proveedor
                </span>
            ),
        },
        {
            field: 'destino',
            headerName: 'Empresa destino',
            flex: 1,
            headerClassName: 'tableHeaders',
            renderHeader: () => (
                <span className="headerTable">
                    Empresa destino
                </span>
            ),
        },
        {

            field: 'actions',
            type: 'actions',
            headerName: 'Acciones',
            flex: 0.5,
            headerClassName: 'tableHeaders',
            getActions: (params) => [
                <Tooltip title="Eliminar" placement="top">
                    <GridActionsCellItem
                        icon={<DeleteIcon />}
                        label="Eliminar"
                        color='primary.main'
                        onClick={() => deleteEnvioEmbarque(params.row)}
                    />
                </Tooltip>
            ],
        },
    ];

    const columnsEmbarqueEditar = [
        {
            field: 'numeroGuia',
            headerName: 'No. de guía',
            flex: 1,
            headerClassName: 'tableHeaders',
            renderHeader: () => (
                <span className="headerTable">
                    No. de guía
                </span>
            ),
        },
        {
            field: 'proveedor',
            headerName: 'Proveedor',
            flex: 1,
            headerClassName: 'tableHeaders',
            renderHeader: () => (
                <span className="headerTable">
                    Proveedor
                </span>
            ),
        },
        {
            field: 'destino',
            headerName: 'Proveedor destino',
            flex: 1,
            headerClassName: 'tableHeaders',
            renderHeader: () => (
                <span className="headerTable">
                    Proveedor destino
                </span>
            ),
        }
    ];

    const handleClose = (event, reason) => {
        if (reason && reason == "backdropClick")
            return;
        setShowDialogEnviosEnEmbarques(false)
    }

    const [modelGuardado, setModelGuardado] = useState(false)
    
    const cerrarModalEmbarque = (e) => {
        e.preventDefault()
        if(!modelGuardado){
            setShowDialogClear(true)
        }else{
            onFinish(true)

        }
    }



    return (
        <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="es-mx" localeText={localeDate.components.MuiLocalizationProvider.defaultProps.localeText}>
            <DialogTitle>
                {esEditar ? 'Editar embarque' : 'Nuevo embarque'}
                <IconButton aria-label="close"
                    onClick={(e) => cerrarModalEmbarque(e)}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                    }}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent>
                <Stepper nonLinear alternativeLabel activeStep={activeStep} connector={<QontoConnector />}>
                    {steps.map((label, index) => {
                        const stepProps = {};
                        const labelProps = {};
                        return (
                            <Step key={label} {...stepProps}>
                                {/* <StepLabel {...labelProps} StepIconComponent={QontoStepIcon}>{label}</StepLabel> */}
                                <StepButton {...labelProps} StepIconComponent={QontoStepIcon} onClick={(e) => { handleStep(index) }}>
                                    {label}
                                </StepButton>
                            </Step>
                        );
                    })}
                </Stepper>
                {activeStep === 0 ? (
                    <React.Fragment>
                        { (modelEmbarque?.Estatus?.toUpperCase() == EnumStatusEmbarqueString.Creado) && 
                            <>
                                <Typography variant="h6">
                                    Selección de guías
                                </Typography>
                                <Grid container columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                                    <Grid item sm={6} md={6} lg={3}>
                                        <TextField
                                            size="small"
                                            margin="normal"
                                            required
                                            fullWidth
                                            id="noGuia"
                                            label="No. de guía"
                                            name="noGuia"
                                            inputProps={{ maxLength: 50 }}
                                            onChange={(e) => {
                                                setValueFiltro("NumeroGuia", e.target.value?.trim())
                                            }}
                                        />
                                    </Grid>
                                    <Grid item sm={6} md={6} lg={3}>
                                        <Autocomplete
                                            size="small"
                                            margin="normal"
                                            fullWidth
                                            id="selectProveedor"
                                            label="Proveedor"
                                            name="selectProveedor"
                                            onChange={(event, newValue) => {
                                                setValueFiltro('IdProveedor', newValue?.id ?? null)
                                            }}
                                            options={proveedoresFiltro.map(a => { return { label: a.proveedores, id: a.id } })}
                                            renderInput={(params) => <TextField size="small" margin="normal" {...params} label="Proveedor" />}
                                        >
                                        </Autocomplete>
                                        {/* <TextField
                                    size="small"
                                    margin="normal"
                                    select
                                    required
                                    fullWidth
                                    id="selectProveedor"
                                    value={filtro.IdProveedor}
                                    label="Proveedor"
                                    onChange={(e) => {
                                        setValueFiltro("IdProveedor", e.target.value)
                                    }}
                                >
                                    <MenuItem value={null}><em>seleccionar</em></MenuItem>
                                    {proveedoresList.map((proveedor) => (
                                        <MenuItem id={proveedor.id} value={proveedor.id}>{proveedor.proveedores}</MenuItem>
                                    ))} 
                                </TextField> */}
                                    </Grid>
                                    <Grid item sm={6} md={6} lg={3}>
                                        <DatePicker
                                            label="Fecha inicio"
                                            value={filtro?.FechaInicio || null}
                                            onChange={(newValue) => setValueFiltro("FechaInicio", newValue)}
                                            renderInput={({ inputRef, inputProps, InputProps }) => (
                                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                    <TextField
                                                        size="small"
                                                        margin="normal"
                                                        fullWidth
                                                        ref={inputRef} {...inputProps}
                                                        label="Fecha inicio"
                                                    />
                                                    {InputProps?.endAdornment}
                                                </Box>
                                            )}
                                        />
                                    </Grid>
                                    <Grid item sm={6} md={6} lg={3}>
                                        <DatePicker
                                            label="Fecha fin"
                                            value={filtro?.FechaFin || null}
                                            onChange={(newValue) => setValueFiltro("FechaFin", newValue)}
                                            renderInput={({ inputRef, inputProps, InputProps }) => (
                                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                    <TextField
                                                        size="small"
                                                        margin="normal"
                                                        fullWidth
                                                        ref={inputRef} {...inputProps}
                                                        label="Fecha fin"
                                                    />
                                                    {InputProps?.endAdornment}
                                                </Box>
                                            )}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container direction={'row'} justifyContent="end" alignItems={"center"} mb={2}>
                                    <Grid item>
                                        <Button
                                            variant="contained"
                                            disabled={!(filtro.NumeroGuia || filtro.IdProveedor || filtro.FechaInicio || filtro.FechaFin)}
                                            onClick={consultarEnviosParaEmbarque}>
                                            Buscar
                                        </Button>
                                    </Grid>
                                </Grid>
                            </>
                        }

                        <Card className="card mb-3">
                            <CardContent>
                                <Grid container direction={'row'} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                                    <Grid item sm={12} md={12} lg={6}>
                                        <Grid container direction={'column'}>
                                            <Grid item textAlign={'center'}>
                                                <Typography variant="h6">
                                                    Guías encontradas
                                                </Typography>
                                            </Grid>
                                            <Grid item mb={2}>
                                                <Box sx={{
                                                    width: '100%',
                                                    '& .tableHeaders': {
                                                        color: 'primary.main',
                                                    },
                                                    marginTop: 2,
                                                }}>
                                                    <DataGrid
                                                        getRowId={(row) => row.idGuia}
                                                        localeText={esES.components.MuiDataGrid.defaultProps.localeText}
                                                        autoHeight
                                                        checkboxSelection={modelEmbarque?.Estatus?.toUpperCase() == EnumStatusEmbarqueString.Creado}
                                                        rows={envios}
                                                        columns={columns}
                                                        dataSource={envios}
                                                        pageSize={pageSize}
                                                        onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                                                        rowsPerPageOptions={[5, 10, 20]}
                                                        pagination
                                                        disableColumnFilter
                                                        disableColumnSelector
                                                        disableDensitySelector
                                                        components={{ Toolbar: GridToolbar }}
                                                        componentsProps={{
                                                            toolbar: {
                                                                showQuickFilter: true,
                                                                quickFilterProps: { debounceMs: 500 },
                                                                csvOptions: { disableToolbarButton: true },
                                                                printOptions: { disableToolbarButton: true },
                                                            },
                                                        }}
                                                        onSelectionModelChange={(ids) => {
                                                            setEnviosSeleccionados(ids)
                                                        }}
                                                    />
                                                </Box>
                                            </Grid>
                                            <Grid item>
                                                {modelEmbarque?.Estatus?.toUpperCase() == EnumStatusEmbarqueString.Creado &&
                                                    <Button
                                                        disabled={(enviosSeleccionados?.length == 0)}
                                                        variant="contained"
                                                        onClick={agregarEnvios}>
                                                        Agregar
                                                    </Button>
                                                }
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                    <Grid item sm={12} md={12} lg={6}>
                                        <Grid container direction={'column'}>
                                            <Grid item textAlign={'center'}>
                                                <Typography variant="h6">
                                                    Guías del embarque
                                                </Typography>
                                            </Grid>
                                            <Grid item mb={2}>
                                                <Box sx={{
                                                    width: '100%',
                                                    '& .tableHeaders': {
                                                        color: 'primary.main',
                                                    },
                                                    marginTop: 2,
                                                }}>
                                                    <DataGrid
                                                        getRowId={(row) => row.idGuia}
                                                        localeText={esES.components.MuiDataGrid.defaultProps.localeText}
                                                        autoHeight
                                                        rows={enviosEmbarque}
                                                        columns={modelEmbarque?.Estatus?.toUpperCase() == EnumStatusEmbarqueString.Creado ? columnsEmbarque : columnsEmbarqueEditar}
                                                        dataSource={enviosEmbarque}
                                                        pageSize={pageSize2}
                                                        onPageSizeChange={(newPageSize) => setPageSize2(newPageSize)}
                                                        rowsPerPageOptions={[5, 10, 20]}
                                                        pagination
                                                        disableColumnFilter
                                                        disableColumnSelector
                                                        disableDensitySelector
                                                        components={{ Toolbar: GridToolbar }}
                                                        componentsProps={{
                                                            toolbar: {
                                                                showQuickFilter: true,
                                                                quickFilterProps: { debounceMs: 500 },
                                                                csvOptions: { disableToolbarButton: true },
                                                                printOptions: { disableToolbarButton: true },
                                                            },
                                                        }}
                                                    />
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>

                            </CardContent>
                        </Card>
                        <Grid container columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                            <Grid item sm={6} md={6} lg={3}>
                                <TextField
                                    size="small"
                                    margin="normal"
                                    required
                                    fullWidth
                                    id="noCartaPorte"
                                    label="No. de carta porte"
                                    name="noCartaPorte"
                                    inputProps={{ maxLength: 50 }}
                                    error={errors.NumeroCartaPorte}
                                    onChange={(e) => {
                                        setValue("NumeroCartaPorte", e.target.value)
                                        setError("NumeroCartaPorte", e.target.value.length <= 0)
                                        setMessage("NumeroCartaPorte",
                                            e.target.value.length <= 0 ? ErrorMessages.embarque.numeroCartaPorte : ""
                                        );
                                    }}
                                    helperText={messages.NumeroCartaPorte}
                                    value={modelEmbarque.NumeroCartaPorte || ""}
                                />
                            </Grid>
                            <Grid item sm={6} md={6} lg={3}>
                                <DatePicker
                                    label="Fecha prevista de llegada"
                                    value={modelEmbarque.FechaEstimadaLlegada || ""}
                                    onChange={(newValue) => {
                                        setValue("FechaEstimadaLlegada", newValue.format());
                                    }}
                                    renderInput={({ inputRef, inputProps, InputProps }) => (
                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                            <TextField
                                                size="small"
                                                margin="normal"
                                                fullWidth
                                                ref={inputRef} {...inputProps}
                                                label="Fecha prevista de llegada"
                                            />
                                            {InputProps?.endAdornment}
                                        </Box>
                                    )}
                                />
                            </Grid>
                            <Grid item sm={12} md={12} lg={6}>
                                <TextField
                                    margin="normal"
                                    required
                                    fullWidth
                                    id="detalles"
                                    label="Detalles del embarque"
                                    name="detalles"
                                    multiline
                                    rows={4}
                                    onChange={(e) => {
                                        setValue("Comentario", e.target.value)
                                    }}
                                    value={modelEmbarque.Comentario || ""}
                                />
                            </Grid>
                        </Grid>
                    </React.Fragment>
                ) : (
                    <React.Fragment>
                        <Grid container direction={'column'} columnSpacing={{ xs: 2, sm: 2, md: 3 }} rowSpacing={2} mb={3}>
                            <Grid item>
                                <Typography variant="h5" color={'success.main'}>
                                    {esEditar ? "¡Embarque editado!" : "¡Embarque creado!"}
                                </Typography>
                            </Grid>
                        </Grid>

                        <Grid container direction={'column'} columnSpacing={{ xs: 2, sm: 2, md: 3 }} rowSpacing={2}>
                            <Grid item>
                                <Typography variant="h5">
                                    Información del embarque
                                </Typography>
                            </Grid>
                            <Grid item>
                                <Card className="card" sx={{ width: '100%', height: 500 }}>
                                    <embed src={urlBlob} type="application/pdf" width="100%" height="600px" />
                                </Card>
                            </Grid>
                        </Grid>
                    </React.Fragment>
                )}

            </DialogContent>

            <DialogActions variant="paddi">
                {
                    (activeStep === 0) &&
                    <Button
                        variant="contained"
                        color="secondary"
                        sx={{ color: '#fff' }}
                        disabled={activeStep === 1}
                        onClick={() => setShowDialogClear(true)}>
                        Cancelar
                    </Button>
                }{
                    (activeStep === 0) &&
                    <Button
                        variant="contained"
                        disabled={errors.NumeroCartaPorte !== false || enviosEmbarque.length == 0 || modelGuardado}
                        onClick={(e) => setShowDialogConfirmar(true)}>
                        Continuar
                    </Button>
                }{
                    (activeStep === steps.length - 1) &&
                    <Button
                        variant="contained"
                        onClick={(e) => {onFinish(true); }}>
                        Cerrar
                    </Button>
                }
            </DialogActions>
            <DialogComponent
                Open={showDialogClear}
                Message="Si cierra o cancela el registro de esta ventana se perderá la información capturada. ¿Está seguro que desea continuar?"
                OnClose={() => setShowDialogClear(false)}
                OnAccept={() => {
                    onClose(false);
                    setShowDialogClear(false);
                }}
            />
            <DialogComponent
                Open={showDialogConfirmar}
                Message="¿Está seguro que todos los datos son correctos?"
                OnClose={() => setShowDialogConfirmar(false)}
                OnAccept={() => {
                    clickContinuar();
                    setShowDialogConfirmar(false);
                }}
            />
            <DialogComponent
                Open={showDialogEnviosEnEmbarques}
                Message={enviosMensajeError}
                OnClose={handleClose}
                OnAccept={handleClose}
            />
            <ModalComponent
                Open={showDialogEnviosNotificacion}
                HandleClose={handleClose}
                ClassName="modal-lg"
                Body={() => (
                    <div>
                        <Grid container spacing={3} mb={2}>
                            <Grid item xs>
                                <h2 style={{ fontSize: 14 }}>
                                    <strong>Envío de actualizaciones</strong>
                                </h2>
                            </Grid>
                            <Grid item xs={6} />
                        </Grid>
                        <Grid container columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                            <DialogTitle>
                                ¿A quién desea mandar el correo de actualización de estatus?
                            </DialogTitle>
                        </Grid>
                        <Grid container columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                            <Grid item sm="6" md="8">
                                {altaEnvios &&
                                    <FormControlLabel
                                        control={<Checkbox value="remember" color="primary" onChange={(event) => {
                                            setValue('NotificacionNuevas', event.target.checked)
                                        }} />}
                                        label="Usuarios de guías nuevas en el embarque "
                                    />
                                }
                            </Grid>
                            <Grid item sm="6" md="8">
                                {bajaEnvios &&
                                    <FormControlLabel
                                        control={<Checkbox value="remember" color="primary" onChange={(event) => {
                                            setValue('NotificacionEliminadas', event.target.checked)
                                        }} />}
                                        label="Usuarios de guías eliminadas del embarque"
                                    />
                                }
                            </Grid>
                            <Grid item sm="6" md="8">
                                <FormControlLabel
                                    control={<Checkbox value="remember" color="primary" onChange={(event) => {
                                        setValue('NotificacionSinModificar', event.target.checked)
                                    }} />}
                                    label="Usuarios de guías sin modificar en el embarque"
                                />
                            </Grid>
                        </Grid>
                        <Grid
                            container
                            direction="row"
                            justifyContent="flex-end"
                            alignItems="center"
                            mt={2}>
                            <Button
                                onClick={(e) => {
                                    e.preventDefault()
                                    rootStore.logisticBackdropStore.openLoading()
                                    setShowDialogEnviosNotificacion(false)
                                    getEmbarqueFile(idEmbarque)
                                    setActiveStep(1)
                                    rootStore.logisticBackdropStore.closeLoading()
                                }}
                                variant="contained"
                                color="secondary"
                                sx={{ color: "#fff" }}>
                                Cancelar
                            </Button>
                            <Button
                                type="submit"
                                onClick={(e) => {
                                    confirmarNotificacionActualizacion(e)
                                }}
                                variant="contained"
                                disabled={!(modelEmbarque.NotificacionNuevas || modelEmbarque.NotificacionEliminadas || modelEmbarque.NotificacionSinModificar)}
                                style={{ marginLeft: 10 }}>
                                Aceptar
                            </Button>
                        </Grid>
                    </div>
                )}
            />
        </LocalizationProvider>
    );
}

export default observer(ModalEmbarques);